import { render, staticRenderFns } from "./topSchools.vue?vue&type=template&id=750fd52f&scoped=true"
import script from "./topSchools.vue?vue&type=script&lang=js"
export * from "./topSchools.vue?vue&type=script&lang=js"
import style0 from "./topSchools.vue?vue&type=style&index=0&id=750fd52f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750fd52f",
  null
  
)

export default component.exports